/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_In_Failed_DescriptionInputs */

const en_auth_sign_in_failed_description = /** @type {(inputs: Auth_Sign_In_Failed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong during sign-in. You can try again or contact your company if the problem continues.`)
};

const pt_br2_auth_sign_in_failed_description = /** @type {(inputs: Auth_Sign_In_Failed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo deu errado durante o login. Tente novamente ou entre em contato com sua empresa se o problema continuar.`)
};

/**
* | output |
* | --- |
* | "Something went wrong during sign-in. You can try again or contact your company if the problem continues." |
*
* @param {Auth_Sign_In_Failed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const auth_sign_in_failed_description = /** @type {((inputs?: Auth_Sign_In_Failed_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_In_Failed_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_sign_in_failed_description(inputs)
	return pt_br2_auth_sign_in_failed_description(inputs)
});